import { render } from "./TheInformations.vue?vue&type=template&id=654a6107&scoped=true&ts=true"
import script from "./TheInformations.vue?vue&type=script&lang=ts"
export * from "./TheInformations.vue?vue&type=script&lang=ts"

import "./TheInformations.vue?vue&type=style&index=0&id=654a6107&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2919933424/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654a6107"]])

export default __exports__